/**
 * Canonical breakpoint scale (single source of truth).
 *
 * Both the Mantine theme (`theme.breakpoints` / `theme.other.size`) and the
 * MUI theme (`theme.breakpoints.values`) reference this file so that the two
 * styling systems resolve identical breakpoints.
 *
 * Values are derived from the px scale that the most responsive consumers use
 * (`useIsMobile` + MUI `theme.breakpoints`): 360 / 768 / 1024 / 1184 / 1440.
 *
 * - `px`  : number map, consumed by MUI `breakpoints.values`.
 * - `rem` : string map (px / 16), consumed by Mantine `breakpoints` and as
 *           layout sizes via `other.size`.
 */

const BASE_FONT_SIZE = 16;

// Canonical px scale (single source of truth).
const px = {
  xs: 360,
  sm: 768,
  md: 1024,
  lg: 1184,
  xl: 1440,
};

const toRem = (value) => `${value / BASE_FONT_SIZE}rem`;

const rem = Object.fromEntries(
  Object.entries(px).map(([key, value]) => [key, toRem(value)])
);

const breakpoints = {
  px,
  rem,
  BASE_FONT_SIZE,
};

export default breakpoints;
export { px, rem, BASE_FONT_SIZE };
